import { render, staticRenderFns } from "./DatasetFilters.vue?vue&type=template&id=8087f130&scoped=true&"
import script from "./DatasetFilters.vue?vue&type=script&lang=js&"
export * from "./DatasetFilters.vue?vue&type=script&lang=js&"
import style0 from "./DatasetFilters.vue?vue&type=style&index=0&id=8087f130&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8087f130",
  null
  
)

export default component.exports